import { render, staticRenderFns } from "./ServiceProviderActiveWidget.vue?vue&type=template&id=73a1242a&"
import script from "./ServiceProviderActiveWidget.vue?vue&type=script&lang=ts&"
export * from "./ServiceProviderActiveWidget.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports